import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-bankgaurantee',
  templateUrl: './bankgaurantee.component.html',
  styleUrls: ['./bankgaurantee.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class BankgauranteeComponent implements OnInit {

  public searchText: string;
  bankname: string;
  guaranteeNum: string;
  ValidFrom: string;
  ValidTo: string;
  gauranteValue: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  BankExport = [] as any;
  EditedBank = [] as any;
  EditedBankId: string;
  Status: boolean = false;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId: string;

  displayedColumns: string[] = ['sno', 'bankname', 'guaranteeNum', 'vFrom1', 'vto1', 'gauranteeValue', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('BankRead');
    this.vWrite = localStorage.getItem('BankWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
    }

    this.BindBankGrid();
    this.BindBankExport();
  }

  SubmitBank() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return false;
    }
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vbankname = this.bankname;
    var vguaranteeNum = this.guaranteeNum;
    var vValidFrom = this.ValidFrom;
    var vValidTo = this.ValidTo;
    var vgauranteValue = this.gauranteValue;
    debugger;


    if (vbankname == undefined || vbankname == "" || vbankname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Bank Name.";
      return false;
    }

    if (vguaranteeNum == undefined || vguaranteeNum == "" || vguaranteeNum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Guarantee Number.";
      return false;
    }

    if (vValidFrom == undefined || vValidFrom == "" || vValidFrom == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidFrom Date.";
      return false;
    }

    if (vValidTo == undefined || vValidTo == "" || vValidTo == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidTo Date.";
      return false;
    }

    if (vgauranteValue == undefined || vgauranteValue == "" || vgauranteValue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Value.";
      return false;
    }

    var vCurrentDate1 = new Date();
    var vFrom1 = new Date(vValidFrom);
    var vTo1 = new Date(vValidTo);
    if ((vTo1) < (vCurrentDate1)) {
      this.isShownError = false;
      this.ErrorMsg = "ValidTo date Should Greater then or equal to Current Date.";
      return false;
    }
    if ((vTo1) < (vFrom1)) {
      this.isShownError = false;
      this.ErrorMsg = "ValidTo date should be greater then ValidFrom date.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dbankname', this.bankname);
    params = params.append('dguaranteeNum', this.guaranteeNum);
    params = params.append('dvalidFrom', this.ValidFrom);
    params = params.append('dvalidTo', this.ValidTo);
    params = params.append('dguarantevalue', this.gauranteValue);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'BankGuaranty/InsertBankGuaranty', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var currencycode = data;
        this.bankname = "";
        this.guaranteeNum = "";
        this.ValidFrom = "";
        this.ValidTo ="";
        this.gauranteValue = "";
        this.SuccessMsg = "BankGuarranty Added."
        this.BindBankExport();
        this.BindBankGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }


  EditBank(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedBank = item;
    var vbankId = this.EditedBank.bankId;
    var vbankname = this.EditedBank.bankname;
    var vguaranteeNum = this.EditedBank.guaranteeNum;
    var vValidFrom = this.EditedBank.vFrom; 
    var vValidTo = this.EditedBank.vto;    
    var vgauranteeValue = this.EditedBank.gauranteeValue;


    this.EditedBankId = vbankId;
    this.bankname = vbankname;
    this.guaranteeNum = vguaranteeNum;    
    this.ValidFrom = new Date(new Date(vValidFrom).setDate(new Date(vValidFrom).getDate() + 1)).toISOString().split('T')[0];   
    this.ValidTo = new Date(new Date(vValidTo).setDate(new Date(vValidTo).getDate() + 1)).toISOString().split('T')[0];    
    this.gauranteValue = vgauranteeValue;
    var vStatus = this.EditedBank.status;
    debugger;
    if (vStatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
  }

  UpdateBank() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownActive =false;
    var vbankname = this.bankname;
    var vguaranteeNum = this.guaranteeNum;
    var vValidFrom = this.ValidFrom;
    var vValidTo = this.ValidTo;
    var vgauranteValue = this.gauranteValue;
    debugger;    

    if (vbankname == undefined || vbankname == "" || vbankname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Bank Name.";
      return false;
    }

    if (vguaranteeNum == undefined || vguaranteeNum == "" || vguaranteeNum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Guarantee Number.";
      return false;
    }

    if (vValidFrom == undefined || vValidFrom == "" || vValidFrom == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidFrom Date.";
      return false;
    }

    if (vValidTo == undefined || vValidTo == "" || vValidTo == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidTo Date.";
      return false;
    }

    if (vgauranteValue == undefined || vgauranteValue == "" || vgauranteValue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Value.";
      return false;
    }

    var vCurrentDate1 = new Date();
    var vFrom1 = new Date(vValidFrom);
    var vTo1 = new Date(vValidTo);
    if ((vTo1) < (vCurrentDate1)) {
      this.isShownError = false;
      this.ErrorMsg = "ValidTo date Should Greater then or equal to Current Date.";
      return false;
    }
    if ((vTo1) < (vFrom1)) {
      this.isShownError = false;
      this.ErrorMsg = "ValidTo date should be greater then ValidFrom date.";
      return false;
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

      let params = new HttpParams();
      params = params.append('iBankId', this.EditedBankId);
      params = params.append('dbankname', this.bankname);
      params = params.append('dguaranteeNum', this.guaranteeNum);
      params = params.append('dvalidFrom', this.ValidFrom);
    params = params.append('dvalidTo', this.ValidTo);
      params = params.append('dguarantevalue', this.gauranteValue);
      params = params.append('istatus',vStatus);
      var value = this.http.get(environment.apiUrl + 'BankGuaranty/UpdateBankGuaranty', { params: params }).toPromise().then(
        (data: any) => {
          debugger;
          var currencycode = data;
          this.bankname = "";
          this.guaranteeNum = "";
          this.ValidFrom = "";
          this.ValidTo ="";
          this.gauranteValue = "";
          this.isShownActive=true;
          this.isShownSaveBtn=false;
          this.isShownUpdateBtn=true;
          this.SuccessMsg = "BankGuarranty Updated."
          this.BindBankExport();
          this.BindBankGrid();
          return false;
        }).catch((data: any) => {
          debugger;
          var vDataError = JSON.stringify(data.error.text);
          var vErrorMsg = vDataError.replace('"', '');
          var vErrorMsg1 = vErrorMsg.replace('"', '');
          if (vErrorMsg1 == "Failed") {
            this.isShownError = false;
            this.ErrorMsg = "Update Failed, Please Try Again.";
            return false;
          }
          else {
          }
        });

  }

  ClearBank() {
    this.bankname = "";
    this.guaranteeNum = "";
    this.ValidFrom = "";
    this.ValidTo ="";
    this.gauranteValue = "";
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
  }

  BindBankGrid() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'BankGuaranty/GetBankGuarantyForGrid',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindBankExport() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'BankGuaranty/GetBankGuarantyForExrt',{ params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.BankExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.BankExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'BankGuarantee');

    /* save to file */
    XLSX.writeFile(wb, "BankGuarantee.xlsx");

  }

}
